<template>
  <div id="cannon" class="text-center">
    <v-card :aspect-ratio="16/9" min-height="350" d-flex class="rounded-card" style="overflow: hidden">
      <v-btn
        fab
        right
        absolute
        width="30"
        height="30"
        class="mt-2 close-button"
        color="blue"
        @click="$emit('onClose')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-container class="px-10 my-auto vertical-center">
        <v-layout row wrap align-center>
          <v-flex class="text-center animate__animated animate__bounce">
            <h1 class="font-weight-black text-uppercase primary--text"
            :class="{
              'text-h6': $vuetify.breakpoint.mdOnly
            }"
            >{{ message }}*</h1>
            <h4 class="text-center primary--text font-italic font-weight-regular mt-10">
              {{ disclaimer }}
            </h4>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <confetti-canon :config="confettiConfig" ref="cannon"/>
  </div>
</template>

<script>
import moment from 'moment'
import ConfettiCanon from '@/components/Helpers/ConfettiCanon.vue'

export default {
  name: 'SuccessSelling',

  components: { ConfettiCanon },

  props: {
    hasBI: { type: Boolean, default: () => false },
    hasFB: { type: Boolean, default: () => false }
  },

  data () {
    return {
      confettiConfig: {
        angle: 90,
        spread: 100,
        startVelocity: 50,
        elementCount: 80,
        dragFriction: 0.11,
        duration: 10000,
        stagger: 26,
        width: '15px',
        height: '15px',
        colors: ['#0420BF', '#1374F2', '#5C9DF2']
        // colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a']
      },
      message: null,
      case1: 'El depósito de tus facturas se reflejará en menos de 4 horas',
      case2: 'El depósito de tus facturas se reflejará en menos de 24 horas',
      case3: 'El depósito de tus facturas se reflejará el próximo día hábil',
      case4: 'El depósito de tus facturas se reflejará de 4 a 6 días hábiles',
      case5: 'El depósito de tus facturas se reflejará de 24 a 72 horas',
      disclaimer: null,
      caseBI: '*Todas las facturas están sujetas a validación, por lo que el tiempo mostrado es informativo y está sujeto a cambios sin previo aviso, no representa un compromiso definitivo por parte de Blú Capital.',
      caseFB: '*Todas las facturas están sujetas a validación por parte de American Industries, por lo que el plazo indicado puede variar y no representa un compromiso definitivo por parte de Blú Capital.',
      caseBIFB: '*Todas las facturas están sujetas a validación (algunas por parte de American Industries), por lo que el tiempo mostrado es informativo y está sujeto a cambios sin previo aviso, no representa un compromiso definitivo por parte de Blu Capital.'
    }
  },

  mounted () {
    this.setMessage()
    this.activateConfetti()
  },

  methods: {
    setMessage () {
      const date = moment().tz('America/Chihuahua')
      const day = date.day()
      const hour = date.hours()
      if (this.hasBI && !this.hasFB) {
        if (day >= 1 && day <= 5) {
          if (hour >= 14) {
            if (day === 5) {
              this.message = this.case3
            } else {
              this.message = this.case2
            }
          } else {
            if (hour >= 8 && hour < 14) {
              this.message = this.case1
            } else {
              this.message = this.case2
            }
          }
        } else {
          this.message = this.case3
        }
        this.disclaimer = this.caseBI
      } else if (this.hasFB && !this.hasBI) {
        this.message = this.case4
        this.disclaimer = this.caseFB
      } else if (this.hasBI && this.hasFB) {
        this.message = this.case5
        this.disclaimer = this.caseBIFB
      }
    },

    activateConfetti () {
      const cannon = document.getElementById('cannon')
      this.$refs.cannon.confetti(cannon.parentNode, this.confettiConfig)
    }
  }
}
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .animate__animated.animate__bounce {
    --animate-delay: 0.5s;
  }
</style>
